import axios from 'axios';
import {
  USER_INFO, ADD_TO_NETWORK, EDIT_SPAM_LIST,
  UNANSWERED_NETWORK_REQUEST_COUNT, DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT,
} from './types';
import { getOwnerId } from '../../../utils/getOwnerId';
import api from '../../../utils/api';

export default {
  async fetchUserInfo({ commit }, userId = '') {
    const id = await getOwnerId();
    const { data } = await axios(api.user.fetchUserInfo(userId || id));
    commit(USER_INFO, { info: data });
    return data;
  },
  async fetchUserInvoices(_, id) {
    const { data } = await axios(api.user.fetchUserInvoices(id));
    return data;
  },
  async editUserInfo({ commit }, editInfo) {
    const { data } = await axios(api.user.editUserInfo(editInfo, getOwnerId()));
    commit(USER_INFO, { info: data });
  },
  async changePassword({}, changePasswords) {
    await axios(api.user.changePassword(changePasswords));
  },
  async forgotPassword({}, data) {
    await axios(api.user.forgotPassword(data));
  },
  async fetchUserPublicInfo({}, id) {
    const customerId = id
      || getOwnerId();
    const { data } = await axios(api.user.fetchUserPublicInfo(customerId));
    return data;
  },
  async searchNetworkUser({}, searchInfo) {
    const searchQuery = searchInfo;
    searchQuery.customerId = searchInfo.customerId || getOwnerId();
    const { data } = await axios(api.user.searchNetworkUser(searchQuery));
    return data;
  },
  async searchOnContacts(_, searchInfo) {
    const searchQuery = searchInfo;
    searchQuery.customerId = searchInfo.customerId || getOwnerId();
    const { data } = await axios(api.user.searchOnContacts(searchQuery));
    return data.results;
  },
  async fetchAllUsers({}, userPage) {
    const { data } = await axios(api.user.fetchAllUsers(userPage));
    return data;
  },
  async fetchInvitationRequests({ commit }, page = 1) {
    const { data } = await axios(
      api.user.fetchInvitationRequests(getOwnerId(), page),
    );
    commit(UNANSWERED_NETWORK_REQUEST_COUNT, data);
    return data;
  },
  async fetchSentInvitationRequests({}, page = 1) {
    const { data } = await axios(
      api.user.sentInvitationRequests(getOwnerId(), page),
    );
    return data;
  },
  // TODO check this endpoint especially commit an return data
  async userInvitationRequest({ commit }, invitationData) {
    const { data } = await axios(
      api.user.userInvitationRequest(invitationData),
    );
    commit(ADD_TO_NETWORK, data);
    return data;
  },
  async approveInvitationRequest({ commit }, invitationUrl) {
    const { data } = await axios(api.user.approveInvitationRequest(invitationUrl));
    commit(DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT);
    return data;
  },
  async refuseInvitationRequest({ commit }, invitationUrl) {
    await axios(api.user.refuseInvitationRequest(invitationUrl));
    commit(DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT);
  },
  async userNetwork({}, page = 1) {
    const { data } = await axios(api.user.userNetwork(page));
    return data;
  },
  async deleteFromNetwork({}, deleteUrl) {
    const data = await axios(api.user.deleteFromNetwork(deleteUrl));
    return data;
  },
  async deleteMember({}, deleteUrl) {
    const data = await axios(api.user.deleteMember(deleteUrl));
    return data;
  },
  async searchCustomer({}, name) {
    const { data } = await axios(api.user.searchCustomer(name));
    return data.results;
  },
  async userRegister(_, userData) {
    const { data } = await axios(api.user.userRegister(userData));
    return data;
  },
  async findCustomers(_, findData) {
    const { data } = await axios(api.user.findCustomers(findData));
    return data;
  },
  async addRemoveSpam({ commit }, spamData) {
    const { data } = await axios(api.user.addRemoveSpam(spamData));
    commit(EDIT_SPAM_LIST, spamData);
    return data;
  },
};
